import { NotificationsPage } from './notifications/notifications.page';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { LoginPage, ForgotenPassPage } from './login/login.page';
import { AccessRoutingModule } from './access.routing.module';
import { ComponentsModule } from '../components/component.module';
import { RegisterPage } from './register/register.page';
import { RatingPage } from './rating/rating.page';
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        FormsModule,
        ReactiveFormsModule,
        AccessRoutingModule,
        ComponentsModule,
        RouterModule.forChild([
            {
                path: 'login',
                component: LoginPage
            }
        ])
    ],
    declarations: [
        LoginPage,
        ForgotenPassPage,
        RegisterPage,
        NotificationsPage,
        RatingPage
    ]
})
export class AccessModule { }
